declare global {
  interface Window {
    _env_: any;
  }
}

export const environment = {
  // helmet meta data
  metaTitle: window._env_.REACT_APP_META_TITLE,
  metaDescription: window._env_.REACT_APP_META_DESC,
  metaUrl: window._env_.REACT_APP_META_URL,
  metaImg: window._env_.REACT_APP_META_IMG,
  metaImgAlt: window._env_.REACT_APP_META_IMG_ALT,
  //
  clientId: window._env_.REACT_APP_IS_CLIENT,
  authority: window._env_.REACT_APP_IS_URL,
  scope: window._env_.REACT_APP_IS_SCOPE,
  silentLoginTimeout: 20000, // ms
  //
  appName: 'Spillguard',
  version: window._env_.REACT_APP_VERSION,
  //
  apiUrl: window._env_.REACT_APP_API_URL,
  subscriberUrl: window._env_.REACT_APP_SUBSCRIBER_URL,
  appVersion: window._env_.REACT_APP_VERSION,
  apiKey: window._env_.REACT_APP_GMAPS_KEY,
  sessionCookieDomain: window._env_.REACT_APP_SESSION_COOKIE_DOMAIN,
  sessionCookieSecure: Boolean(window._env_.REACT_APP_SESSION_COOKIE_SECURE),
  sessionCookieIdleTimeout: Number(window._env_.REACT_APP_SESSION_COOKIE_IDLE_TIMEOUT),
  //
  clarityId: window._env_.REACT_APP_CLARITY_ID,
};
